import * as actionTypes from "../Action/actionTypes";

let initialState = {
  academicDetails: [],
  collegeDetails: [],
  courseDetails: [],
  streamDetails: []
}

export function academiclists(state = initialState, action) {
  switch(action.type) {
    /* Starting various actions. */
    case actionTypes.GET_ACADEMIC_DETAILS_START:
      return { 
        ...state,
        loading: true,
      };
    case actionTypes.GET_COLLEGE_DETAILS_START:
      return { 
        ...state,
        loading: true,
      };
    case actionTypes.GET_COURSE_DETAILS_START:
      return { 
        ...state,
        loading: true,
        courseDetails: [],
      };
    case actionTypes.GET_STREAM_DETAILS_START:
      return { 
        ...state,
        loading: true,
      };

    /* For failed actions. */
    case actionTypes.GET_ACADEMIC_DETAILS_FAIL:
      return { 
        ...state,
        loading: false,
      };
    case actionTypes.GET_COLLEGE_DETAILS_FAIL:
      return { 
        ...state,
        loading: false,
      };
    case actionTypes.GET_COURSE_DETAILS_FAIL:
      return { 
        ...state,
        loading: false,
      };
    case actionTypes.GET_STREAM_DETAILS_FAIL:
      return { 
        ...state,
        loading: false,
      };

    /* For successful actions. */
    case actionTypes.GET_ACADEMIC_DETAILS_SUCCESS:
      return { 
        ...state,
        loading: false,
        academicDetails: action.data,
        collegeDetails: [],
        courseDetails: [],
        streamDetails: []
      };
    case actionTypes.GET_COLLEGE_DETAILS_SUCCESS:
      return { 
        ...state,
        loading: false,
        collegeDetails: action.data,
        courseDetails: [],
        streamDetails: []
      };
    case actionTypes.GET_COURSE_DETAILS_SUCCESS:
      return { 
        ...state,
        loading: false,
        courseDetails: action.data,
        streamDetails: []
      };
    case actionTypes.GET_STREAM_DETAILS_SUCCESS:
      return { 
        ...state,
        loading: false,
        streamDetails: action.data
      };

    default:
      return state;
  }
}
export default academiclists;
